<template>
  <main class="gc-page">
    <section class="gc-hero about-hero" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="gc-hero-content">
        <h1>关于 19.9</h1>
        <p class="hero-tagline">掌控主动权，按自己的方式赚钱。</p>
        <p class="hero-intro">19.9 将主动权重新交到您手中。这个去中心化的数字公告板帮助您发现、提供和交换本地服务——没有佣金、没有算法、没有企业中间商的干预。</p>
      </div>
    </section>

    <section class="gc-section about-content">
      <div class="gc-container">
        <h2 class="about-title"><span>现代社区</span>的数字公告板</h2>
        <div class="about-split">
          <div class="about-text">
            <p class="about-body">
              从武汉出发，19.9 为当今移动优先的世界重新构想了传统社区公告板。
            </p>
            <p class="about-body">
              <strong>没有算法决定您的曝光。</strong>
            </p>
            <p class="about-body">
              <strong>没有企业中间商抽成。</strong>
            </p>
            <p class="about-body">
              <strong>没有偏向平台而非用户的复杂规则。</strong>
            </p>
          </div>
          <div class="about-image">
            <img src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/Irvine-scaled.webp" alt="Irvine">
          </div>
        </div>
      </div>
    </section>

    <section class="gc-section about-steps">
      <div class="gc-container">
        <h2 class="about-title">一个<span>简单直接</span>的方式：</h2>
        <div class="step-cards">
          <div class="step-item">
            <img src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/1.webp" alt="">
            <p>发布您的需求</p>
          </div>
          <div class="step-item">
            <img src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/2.webp" alt="">
            <p>提供您的技能</p>
          </div>
          <div class="step-item">
            <img src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/3.webp" alt="">
            <p>直接连接</p>
          </div>
          <div class="step-item">
            <img src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/4.webp" alt="">
            <p>自行商定条款</p>
          </div>
        </div>
      </div>
    </section>

    <section class="about-hero-panel">
      <div class="about-hero-overlay"></div>
      <div class="about-hero-inner">
        <h2 class="ahp-title">为日常而生</h2>
        <h3 class="ahp-subtitle">实干家</h3>
        <div class="ahp-icon-box">
          <div class="ahp-icon-wrap">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="ahp-svg ahp-svg-def" width="48" height="48"><path d="M512.2 516.5c-68.6 0-133.1-26.7-181.5-75.2s-75.2-113-75.2-181.5 26.7-133.1 75.2-181.5S443.6 3 512.2 3s133.1 26.7 181.5 75.2c48.5 48.5 75.2 113 75.2 181.5s-26.7 133.1-75.2 181.5c-48.4 48.6-112.9 75.3-181.5 75.3z m0-433.5c-97.5 0-176.7 79.3-176.7 176.7 0 97.5 79.3 176.7 176.7 176.7S689 357.2 689 259.7C689 162.3 609.7 83 512.2 83zM881 1024c-22.1 0-40-17.9-40-40V777.4c0-82-62.1-149.8-141.8-158.8L543.9 807c-7.6 9.2-18.9 14.5-30.8 14.6h-0.1c-11.9 0-23.1-5.3-30.7-14.4L325.4 618.5c-79.7 8.9-141.9 76.8-141.9 158.8V984c0 22.1-17.9 40-40 40s-40-17.9-40-40V777.4c0-64.1 24.9-124.3 70.2-169.6 45.3-45.3 105.5-70.2 169.6-70.2 11.9 0 23.1 5.3 30.7 14.4l138.8 166.9 137.4-166.7c7.6-9.2 18.9-14.6 30.9-14.6 64.1 0 124.3 24.9 169.6 70.2S921 713.3 921 777.4V984c0 22.1-17.9 40-40 40z" fill="#1B5BA6"/><path d="M512 400.2c-77.3 0-140.1-62.9-140.1-140.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0 33.2 27 60.1 60.1 60.1 33.2 0 60.1-27 60.1-60.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0.1 77.2-62.8 140.1-140.1 140.1zM767 846H667c-22.1 0-40-17.9-40-40s17.9-40 40-40h100c22.1 0 40 17.9 40 40s-17.9 40-40 40z" fill="#1B5BA6"/></svg>
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="ahp-svg ahp-svg-hov" width="48" height="48"><path d="M512.2 516.5c-68.6 0-133.1-26.7-181.5-75.2s-75.2-113-75.2-181.5 26.7-133.1 75.2-181.5S443.6 3 512.2 3s133.1 26.7 181.5 75.2c48.5 48.5 75.2 113 75.2 181.5s-26.7 133.1-75.2 181.5c-48.4 48.6-112.9 75.3-181.5 75.3z m0-433.5c-97.5 0-176.7 79.3-176.7 176.7 0 97.5 79.3 176.7 176.7 176.7S689 357.2 689 259.7C689 162.3 609.7 83 512.2 83zM881 1024c-22.1 0-40-17.9-40-40V777.4c0-82-62.1-149.8-141.8-158.8L543.9 807c-7.6 9.2-18.9 14.5-30.8 14.6h-0.1c-11.9 0-23.1-5.3-30.7-14.4L325.4 618.5c-79.7 8.9-141.9 76.8-141.9 158.8V984c0 22.1-17.9 40-40 40s-40-17.9-40-40V777.4c0-64.1 24.9-124.3 70.2-169.6 45.3-45.3 105.5-70.2 169.6-70.2 11.9 0 23.1 5.3 30.7 14.4l138.8 166.9 137.4-166.7c7.6-9.2 18.9-14.6 30.9-14.6 64.1 0 124.3 24.9 169.6 70.2S921 713.3 921 777.4V984c0 22.1-17.9 40-40 40z" fill="#fff"/><path d="M512 400.2c-77.3 0-140.1-62.9-140.1-140.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0 33.2 27 60.1 60.1 60.1 33.2 0 60.1-27 60.1-60.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0.1 77.2-62.8 140.1-140.1 140.1zM767 846H667c-22.1 0-40-17.9-40-40s17.9-40 40-40h100c22.1 0 40 17.9 40 40s-17.9 40-40 40z" fill="#fff"/></svg>
          </div>
          <p class="ahp-desc">为遛狗人、家教老师、拼车司机、家庭维修专家、短租房东，以及正在建立自己事业的副业者而建。我们为那些更喜欢真实连接而非企业把关的邻居而存在。</p>
        </div>
        <p class="ahp-bottom-text">
          <strong>19.9 让你</strong>轻松开启一份副业——或者两份、三份。<br>
          <strong style="font-size: 1rem;">你决定提供什么服务。你制定自己的价格。你管理自己的沟通。你保留 100% 的收入。</strong>
        </p>
        <div class="ahp-cta-wrap">
          <a class="ahp-cta" href="#download">
            下载 APP
            <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18"/>
            </svg>
          </a>
        </div>
      </div>
    </section>

    <section class="gc-section abp-pricing">
      <div class="gc-container">
        <h2 class="abp-title">简单。透明。公平。</h2>
        <p class="abp-sub">我们的模式简单明了。</p>

        <div class="abp-card">
          <div class="abp-card-inner">
            <p class="abp-card-label" style="font-weight: bold;font-size: 3rem;">每月每个类别</p>
            <p class="abp-card-price" style="margin: 10% 0  50% 0;">￥19.90</p>
            <a class="ahp-cta" href="#download">
              立即开始！
              <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18"/>
              </svg>
            </a>
          </div>
        </div>

        <h3 class="abp-thatsit">仅此而已！</h3>
        <p class="abp-desc">
          没有佣金比例。没有意外的扣款。没有隐藏在细文中的费用。<br>
          一分钟内发布或请求一项服务。根据您的需求本地匹配。<br>
          自由畅聊。保持掌控。
        </p>
      </div>
    </section>

    <section class="abp-community">
      <div class="abp-community-overlay"></div>
      <div class="abp-community-inner">
        <h2 class="abp-community-title">为真实连接<span>而设计的市场</span></h2>
        <div class="abp-community-text">
          <p><strong>19.9</strong> 不是为了扩大企业机器。而是为了加强本地社区。</p>
          <p>当邻居直接连接，价值留在本地。</p>
          <p>当服务者保留全部收入，机会就会扩大。</p>
          <p>当平台不再干预，信任就会增长。</p>
          <p><strong>这是一个重新连接的社区。</strong></p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'AboutView',
  data() {
    return {
      heroImage: 'https://goodconnex.com/wp-content/uploads/2026/02/About-Banner.jpg'
    }
  }
}
</script>

<style scoped>
/* Hero — all text over background image */
.about-hero {
  min-height: 700px;
}

.hero-tagline {
  max-width: 780px;
  margin: 48px auto 0;
  font-size: clamp(22px, 3vw, 36px);
  line-height: 1.15;
  font-weight: 900;
  text-shadow: 3px 4px 0 rgba(0, 0, 0, 0.22);
}

.hero-intro {
  max-width: 820px;
  margin: 28px auto 0;
  font-size: 18px;
  line-height: 1.7;
  font-weight: 500;
  text-shadow: 1px 2px 0 rgba(0, 0, 0, 0.2);
}

/* Content section */
.about-content {
  background: #fff;
}

.about-title {
  width: 100%;
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 900;
  line-height: 1.12;
  margin-bottom: 56px;
  color: #1f2933;
  text-align: center;
  white-space: nowrap;
}

.about-title span {
  color: #1765b2;
}

.about-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 72px;
  align-items: center;
  text-align: left;
}

.about-body {
  font-size: 19px;
  line-height: 1.7;
  color: #1f2933;
  margin-bottom: 14px;
}

.about-body strong {
  color: #1f2933;
}

.about-image img {
  width: 100%;
  border-radius: 8px;
}

/* Step cards */
.about-steps {
  background: #fff;
}

.about-steps .about-title {
  text-align: left;
  white-space: normal;
}

.step-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  margin-top: 24px;
}

.step-item {
  border: 2px solid #A75F26;
  border-radius: 12px;
  padding: 24px 20px 28px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.step-item:hover {
  transform: scale(1.06);
  box-shadow: 0 14px 36px rgba(167, 95, 38, 0.18);
}

.step-item img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 18px;
}

.step-item p {
  color: #1765b2;
  font-size: 18px;
  font-weight: 900;
}

/* Hero image panel */
.about-hero-panel {
  position: relative;
  min-height: 650px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 28px;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/About-Us-Block2.jpg") center/cover;
}

.about-hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(27, 91, 166, 0.55);
  z-index: 1;
}

.about-hero-inner {
  position: relative;
  z-index: 2;
  max-width: 820px;
  text-align: center;
}

.ahp-title {
  font-size: clamp(48px, 7vw, 80px);
  font-weight: 900;
  color: #fff;
  line-height: 1.05;
  margin-bottom: 4px;
}

.ahp-subtitle {
  font-size: clamp(48px, 7vw, 80px);
  font-weight: 900;
  color: #F5EBD0;
  line-height: 1.05;
  text-decoration: underline;
  text-underline-offset: 12px;
  text-decoration-thickness: 4px;
  margin-bottom: 42px;
}

.ahp-icon-box {
  background: rgba(245, 235, 208, 0.5);
  border-radius: 20px;
  padding: 48px 44px;
  max-width: 780px;
  margin: 0 auto 42px;
}

.ahp-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  margin-bottom: 24px;
}

.ahp-svg {
  position: absolute;
}

.ahp-svg-def {
  display: block;
}

.ahp-svg-hov {
  display: none;
}

.ahp-icon-wrap:hover {
}

.ahp-icon-wrap:hover .ahp-svg-def {
  display: none;
}

.ahp-icon-wrap:hover .ahp-svg-hov {
  display: block;
}

.ahp-desc {
  color: #000;
  font-size: 18px;
  line-height: 1.75;
  font-weight: 500;
  text-align: center;
}

.ahp-bottom-text {
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
  max-width: 760px;
  margin: 0 0 36px;
  text-align: left;
  width: 100%;
}

.ahp-bottom-text strong {
  font-weight: 800;
}

.ahp-cta-wrap {
  text-align: left;
}

.ahp-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 56px;
  padding: 0 36px;
  border-radius: 10px;
  background: #1B5BA6;
  color: #fff;
  text-decoration: none;
  font-weight: 800;
  font-size: 18px;
  transition: background 0.2s;
  box-shadow: 0 4px 16px rgba(27, 91, 166, 0.4);
}

.ahp-cta:hover {
  background: #174a8a;
}

.ahp-cta .phone-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Pricing section */
.abp-pricing {
  background: #fff;
  text-align: center;
}

.abp-title {
  font-size: clamp(42px, 6vw, 68px);
  font-weight: 900;
  color: #1f2933;
  margin-bottom: 18px;
  line-height: 1.05;
}

.abp-sub {
  font-size: 20px;
  color: #68717b;
  margin-bottom: 52px;
}

.abp-card {
  max-width: 520px;
  margin: 0 auto 52px;
  border-radius: 16px;
  overflow: hidden;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/LOGO-Banner_Final.jpg") center/cover;
  position: relative;
}

.abp-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(245, 235, 208, 0.78);
  z-index: 1;
}

.abp-card-inner {
  position: relative;
  z-index: 2;
  padding: 56px 36px;
}

.abp-card-label {
  color: #1765b2;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 14px;
}

.abp-card-price {
  color: #A75F26;
  font-size: clamp(60px, 9vw, 96px);
  font-weight: 900;
  line-height: 1;
  margin-bottom: 32px;
}

.abp-thatsit {
  color: #1765b2;
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 900;
  margin-bottom: 24px;
}

.abp-desc {
  max-width: 720px;
  margin: 0 auto;
  font-size: 19px;
  line-height: 1.8;
  color: #68717b;
}

/* Community panel */
.abp-community {
  position: relative;
  min-height: 650px;
  display: flex;
  align-items: center;
  padding: 100px 28px;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/About-Us-Block3b.webp") center/cover;
}

.abp-community-overlay {
  position: absolute;
  inset: 0;
  background: rgba(27, 91, 166, 0.55);
  z-index: 1;
}

.abp-community-inner {
  position: relative;
  z-index: 2;
  width: min(1120px, 100%);
  margin: 0 auto;
}

.abp-community-title {
  font-size: clamp(40px, 5.5vw, 64px);
  font-weight: 900;
  color: #fff;
  line-height: 1.1;
  margin-bottom: 48px;
}

.abp-community-title span {
  color: #F5EBD0;
}

.abp-community-text {
  text-align: left;
  max-width: 720px;
}

.abp-community-text p {
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
  margin-bottom: 12px;
}

.abp-community-text p strong {
  font-weight: 800;
}

@media (max-width: 860px) {
  .abp-community {
    min-height: 480px;
    padding: 72px 24px;
  }

  .abp-community-title {
    font-size: clamp(30px, 7vw, 44px);
    margin-bottom: 32px;
  }

  .abp-community-text p {
    font-size: 16px;
    line-height: 1.7;
  }

  .about-hero {
    min-height: 560px;
  }

  .hero-intro {
    font-size: 15px;
    line-height: 1.6;
  }

  .about-split {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-title {
    font-size: clamp(28px, 7vw, 40px);
    margin-bottom: 36px;
    white-space: normal;
  }

  .about-body {
    font-size: 16px;
  }

  .step-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .about-hero-panel {
    min-height: 480px;
    padding: 72px 24px;
  }

  .ahp-icon-box {
    padding: 32px 22px;
  }

  .ahp-desc {
    font-size: 15px;
  }

  .ahp-bottom-text {
    font-size: 16px;
  }

  .abp-card-inner {
    padding: 40px 24px;
  }

  .abp-desc {
    font-size: 16px;
  }
}
</style>
